// client and server can read from this config file. not secure

export default {
  defaultBrand: 'hotpads',
  brands: {
    hotpads: 'hotpads',
    trulia: 'trulia',
    zillow: 'zillow',
  },
  brandTitles: {
    hotpads: 'HotPads',
    trulia: 'Trulia',
    zillow: 'Zillow',
  },
  brandUrls: {
    hotpads: 'https://hotpads.com',
    trulia: 'https://www.trulia.com',
    zillow: 'https://www.zillow.com',
  },
};
